<div class="headers_bg col-12 p-0"
  [ngClass]="{'headerSubHeaderHeight': subHeaderShow, 'headerOnlyHeight': !subHeaderShow}" *ngIf="hideOnReset">

  <!-- Header -->
  <headerSelector></headerSelector>
  <!-- Header -->

  <!-- subHeader -->
  <app-subheader *ngIf="subHeaderShow || editOrderAddingAnotherItem"></app-subheader>
  <!-- subHeader -->
</div>

<!--Calendar-->
<app-calendar *ngIf="showCalendar"></app-calendar>

<!--My Cart-->
<!-- <app-my-cart class="myCartHost" [ngClass]="{'top_135': subHeaderShow, 'top_279': showCategories || showAppItemDetailHeader, 'minHeightFull': showMyCart}"></app-my-cart> -->
<app-my-cart class="myCartHost top_279" [ngClass]="{'minHeightFull': showMyCart}"></app-my-cart>

<!-- Main Routing -->
<router-outlet></router-outlet>
<!-- Main Routing -->

<app-loader></app-loader>

<!-- footer -->
<app-footer *ngIf="hideOnReset && !showMyCart"></app-footer>
<!-- footer -->


// WEBPACK FOOTER //
// ./src/app/app.component.html